import { memo } from 'react';
import { useSelector } from 'react-redux';
import StarRating from '@components/StarRating';
import ProductPricing from './ProductPricing';
import useVariation from '@hooks/useVariation';

const MobileHeader = ({ pricingItem, addOns, includeAggregateRating = true }) => {
  const { details } = useSelector((state: any) => state.pdpItem);
  const { displayNameOnPage, rating } = details || {};
  const isVariant = useVariation('Enhanced PDP');

  if (!details) return null;

  if (isVariant)
    return (
      <div className='tw:mb-2 tw:flex tw:w-full tw:items-center tw:justify-between tw:border-b tw:border-b-gray-200 tw:py-2'>
        <ProductPricing variant='mobile-header' item={pricingItem} addOns={addOns} />
      </div>
    );

  return (
    <div className='tw:mb-2 tw:flex tw:w-full tw:items-center tw:justify-between tw:border-b tw:border-b-gray-200 tw:py-2'>
      <div className='tw:inline-flex tw:w-1/2 tw:items-center tw:lg:mb-auto'>
        <StarRating
          includeAggregateRating={includeAggregateRating}
          itemName={displayNameOnPage}
          reviewRating={rating.rating}
          reviewCount={rating.count}
          showReviewCount
          showReviewLabel
          starsColor='#1F1F1F'
          fontSize='12px'
          labelClassName='tw:text-left tw:!text-xs tw:!ml-0 tw:!block'
          starsWrapperClassName='tw:!text-left'
          rootWrapperClassName='tw:!mb-0'
        />
      </div>
      <div className='tw:inline-flex tw:justify-end tw:text-right'>
        <ProductPricing variant='mobile-header' item={pricingItem} addOns={addOns} />
      </div>
    </div>
  );
};

export default memo(MobileHeader);
